<template>
    <header v-if="!error && !isLoading" class="c-o-site-header" :class="{'c-o-site-header--theme-alt': showCompanyHeader}">
        <div v-if="showCompanyHeader" class="c-o-site-header__banner">
            <img class="c-o-site-header__logo-img hemmafixarna" :src="leftImgSrc" alt="Hemmafixarnas logotyp">

            <router-link :to="'/for-hantverkare/'" aria-label="'Länk till startsida för hantverkare'" class="c-o-site-header__logo">
                <img class="c-o-site-header__logo-img" :src="logoSrc" alt="BraByggares logotyp">
            </router-link>
            <div class="c-o-site-header__cta no-print">
                <router-link to="/" aria-label="Gå till startsida för beställare" class="sh-link-no-underline">
                    <div class="c-a-button c-a-button--theme-primary">
                        <icon icon="person" />
                        <span>Är du beställare?</span>
                    </div>
                </router-link>
                
            </div>
        </div>
        <div v-else class="c-o-site-header__banner">
            <img class="c-o-site-header__logo-img hemmafixarna" :src="leftImgSrc" alt="Hemmafixarnas logotyp">

            <router-link :to="{name: 'Hem'}" aria-label="'Länk till startsida för beställare'" class="c-o-site-header__logo">
                <img class="c-o-site-header__logo-img" :src="logoSrc" alt="BraByggares logotyp">
            </router-link>
            <div class="c-o-site-header__cta no-print">
                <router-link :to="{name: 'Hem (Hantverkare)'}" aria-label="Gå till startsida för beställare" class="sh-link-no-underline">
                    <div class="c-a-button c-a-button--theme-primary">
                        <icon icon="hammer_and_wrench" />
                        <span>Anslut ditt företag</span>
                    </div>
                </router-link>
            </div>
        </div>
        <div
            v-if="isMounted && ($mq === 'xSmall' || $mq === 'small' || $mq === 'medium')"
            class="c-o-site-header__toggle no-print"
            @click="toggleMenu"
        >
            <hamburger :toggled="showMobileMenu" :ariaLabel="'Öppna/stäng huvudmeny'" :ariaControls="'header-nav'"></hamburger>
            <span v-if="showMobileMenu" class="c-o-site-header__toggle-label">Stäng meny</span>
            <span v-else class="c-o-site-header__toggle-label">Öppna meny</span>
        </div>
        <site-menu-mobile
            v-if="isMounted && ($mq === 'xSmall' || $mq === 'small' || $mq === 'medium')"
            v-show="showMobileMenu"
            :isCompany="showCompanyHeader"
            :items="menuItems"
        ></site-menu-mobile>
        <site-menu-desktop
            v-else
            :items="menuItems"
        ></site-menu-desktop>
    </header>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';

    import { GET_HEADER_MENU, GET_ERROR, IS_LOADING, GET_COMPANY_MENU } from '../../../store/store-models/meta-model';
    import { SET_SHOW_COMPANY_HEADER, GET_SHOW_COMPANY_HEADER, SET_SHOW_MOBILE_MENU, GET_SHOW_MOBILE_MENU } from  '../../../store/store-models/app-model';

    import ButtonAtom from '../atoms/AtomButton.vue';
    import Hamburger from '../atoms/AtomHamburger.vue';
    import SiteMenuMobile from '../molecules/MoleculeMenuMobile.vue';
    import SiteMenuDesktop from '../molecules/MoleculeMenuDesktop.vue';
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        asyncData ({ store, route }) {
            if (route.name === 'HomeCompany') {
                store.commit(SET_SHOW_COMPANY_HEADER, true);
            }
            return Promise.resolve();
        },
        components: {
            ButtonAtom,
            Hamburger,
            SiteMenuMobile,
            SiteMenuDesktop,
            Icon
        },
        data () {
            return {
                isMounted: false,
                leftImgSrc: "/assets/images/logo/En-del-av-Hemfixarna.png"
            }
        },
        props: {
            modifiers: String
        },
        computed: {
            ...mapGetters({
                isLoading: IS_LOADING,
                error: GET_ERROR,
                showCompanyHeader: GET_SHOW_COMPANY_HEADER,
                showMobileMenu: GET_SHOW_MOBILE_MENU,
                customerMenu: GET_HEADER_MENU,
                companyMenu: GET_COMPANY_MENU
            }),
            menuItems: function() {
                return this.showCompanyHeader ? this.companyMenu : this.customerMenu
            },
            logoSrc: function() {
                const base = '/assets/images/logo/';
                let file = '';

                if (this.showCompanyHeader && (this.$mq === 'large' || this.$mq === 'xLarge')) {
                    file = 'Brabyggare-logo-RGB-neg.png';
                } else if (this.showCompanyHeader) {
                    file = 'Brabyggare-logo-RGB-neg.png';
                } else if (this.$mq === 'large' || this.$mq === 'xLarge') {
                    file = 'Brabyggare-logo.png';
                } else {
                    file = 'Brabyggare-logo.png';
                }

                return base + file;
            }
        },
        methods: {
            ...mapMutations({
                setShowCompanyHeader: SET_SHOW_COMPANY_HEADER
            }),
            toggleMenu: function () {
                if( this.showMobileMenu === true ) {
                    this.$store.commit(SET_SHOW_MOBILE_MENU, false);
                } else {
                    this.$store.commit(SET_SHOW_MOBILE_MENU, true);
                }
            },
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismSiteHeader.vue